// extracted by mini-css-extract-plugin
export default {"color1":"#222831","color2":"#30475e","color3":"#f05454","color4":"#ddd"};